import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { deleteProduct, getProducts, updateRelatedProducts } from "helpers/API Calls/Operations/Products";
import { generateQueryParams } from "helpers/queryParams";
import { Link } from "react-router-dom";
import convertDateFormat from "Components/Date/DateFormat";
import DeleteModal from "Components/Modals/DeleteModal";
import LinkProductsModal from "./LinkProductsModal";
import { ProductData } from "types/Product";

const head = [
  {id: 1, name: "#", isSortable: true, key: "id"},
  {id: 2, name: "Product", isSortable: true, key: "product_name"},
  {id: 3, name: "Type", isSortable: true, key: "product_type_id"},
  {id: 5, name: "Price", isSortable: true, key: "price"},
  {id: 10, name: "SKU", isSortable: false, key: "sku"},
  {id: 6, name: "Category", isSortable: true, key: "main_category_id"},
  {id: 4, name: "Status", isSortable: true, key: "status"},
  {id: 7, name: "Created", isSortable: true, key: "created_at"},
  {id: 8,name: "Updated", isSortable: true, key: "updated_at"},
  {id: 9,name: "Actions"}
]

function Products() {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<ProductData[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getProducts(generateQueryParams(filters));
    if (response.success) {
      setProducts(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteProduct(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };

  const [relatedProductModal, setRelatedProductModal] = useState<boolean>(false);  

  const handleRelatedProductClick = (item) => {
    setSelectedItem(item);
    setRelatedProductModal(true);
  };

  const handleRelatedProductConfirm = async (data: any) => {
    if (selectedItem) {
      const response = await updateRelatedProducts(selectedItem.id, data);
      if (response.success) {
        setRelatedProductModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  }

  return (
    <>
    <div className="page-content">
      <Container fluid >
        <Breadcrumb items={[{ label: "Products", link: "/products" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
              customButton={
                 <div className='d-flex justify-content-end mb-3 align-items-center '>
                <Link to={"/products/create"} className= "btn btn-primary me-2"><i className="mdi mdi-plus me-1"></i>Create Custom Product</Link>
                <Link to={'/products/create/bulk'} className= "btn btn-primary"><i className="mdi mdi-plus me-1"></i>Upload CSV</Link>
                </div>
              }
            > 
              {products.length > 0 && products.map((item: ProductData) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.product_name}</td>
                    <td>{item?.product_type?.product_type_name}</td>
                    <td>{item?.product_price?.price}</td>
                    <td>{item?.sku}</td>
                    <td>{item?.main_category?.category_name}</td>
                    <td>
                      <span className={`badge badge-soft-${item.status === 'active' ? 'success' : 'danger'}`}>
                        {item?.status?.charAt(0).toUpperCase() + item?.status?.slice(1)}
                      </span>
                    </td>
                    <td>{convertDateFormat(item.created_at)}</td>
                    <td>{convertDateFormat(item.updated_at)}</td>
                    <td>
                      <div>
                        {/* <a href={item?.link} className="btn btn-warning btn-sm me-1"><i className="bx bx-eye"/></a> */}
                        <button className="btn btn-warning btn-sm" onClick={() => handleRelatedProductClick(item)}><i className="mdi mdi-relation-many-to-one"></i></button>
                        <Link to={`${item.id}/edit`} className="btn btn-primary btn-sm mx-1"><i className="bx bx-pencil"/></Link>
                        <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                      </div>
                    </td>
                  </tr>))
                }
                {!isLoading && products.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
                
            </PaginatedTable>
          </CardBody>
        </Card>}
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`${selectedItem?.product_name} product?`}
    />}
    {relatedProductModal && <LinkProductsModal
      isOpen={relatedProductModal}
      toggle={() => {setRelatedProductModal(prev => !prev); setSelectedItem(null)}}
      product={selectedItem}
      products={products}
      onSave={handleRelatedProductConfirm}
    />}
    </>
  );
}

export default Products;
